import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Pagination from "react-js-pagination";
import moment from "moment";
import NumberFormat from "react-number-format";

import {
  getListDanhSachDonDatHang,
  updateDataSearch,
} from "../../../actions/DanhSachDonDatHang";

import ChiNhanhApi from "service/DanhMucService/ChiNhanhApi";
import { getBranch, getUserLogin, LamTronNghin } from "utils/utils";
import { BtnSua } from "./ChucNang/Sua/BtnSua";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { Cookies } from "react-cookie";

export default function TableDonDatHang({
  isLamTronTien,
  listDonHang,
  dataSearch,
}) {
  const dispatch = useDispatch();
  const [lstChiNhanh, setLstChiNhanh] = useState([]);

  useEffect(() => {
    document.title = "Đại Lý - Danh sách đơn đặt hàng";

    ChiNhanhApi.listChiNhanh(getUserLogin().UserName).then((response) => {
      if (response.data.List.length > 0) {
        const lst = response.data.List.filter((x) => x.BranchID !== 0);
        setLstChiNhanh(lst);
      }
    });

    if (getBranch() === 0 || getBranch() === "0") {
      ChiNhanhApi.listChiNhanh(getUserLogin().UserName).then((response) => {
        if (response.data.List.length > 0) {
          const lst = response.data.List.filter((x) => x.BranchID !== 0);
          const reducedArray = lst.reduce(
            (acc, curr) => `${acc}${curr.BranchID}_`,
            "",
          );

          const stringNew = reducedArray.slice(0, -1);

          const searchNew = {
            ...dataSearch,
            sBranch: stringNew,
            // trạng thái mặc định riêng màn này
            sTrangThai: "0",

            // lùi 90 ngày
            tuNgay: moment().subtract(90, "days").format("YYYY-MM-DD"),

            // ngày hiện tại
            denNgay: moment().format("YYYY-MM-DD"),
          };

          applyUrlSearch(searchNew);
          dispatch(getListDanhSachDonDatHang(searchNew));
          dispatch(updateDataSearch(searchNew));
        }
      });
    } else {
      const searchNew = {
        ...dataSearch,
        // trạng thái mặc định riêng màn này
        sTrangThai: "0",

        // lùi 90 ngày
        tuNgay: moment().subtract(90, "days").format("YYYY-MM-DD"),

        // ngày hiện tại
        denNgay: moment().format("YYYY-MM-DD"),
      };
      applyUrlSearch(searchNew);
      dispatch(getListDanhSachDonDatHang(searchNew));
      dispatch(updateDataSearch(searchNew));
    }
  }, []);

  const applyUrlSearch = (searchNew) => {
    const params = new URLSearchParams(window.location.search);
    const search = params.get("search");
    const loai = params.get("loai");
    const customerID = params.get("customerID");

    if (loai === "macode" && search !== "") {
      searchNew.sSearch = search;
    } else if (loai === "khachhang" && search !== "") {
      searchNew.sCustomerName = search;

      if (customerID > 0) {
        searchNew.fromDate = moment().startOf("year").format("YYYY-MM-DD");
        searchNew.toDate = moment().endOf("year").format("YYYY-MM-DD");
      }
    }
  };

  const viewDonDatHang = (orderDatHangID) => {
    window.open(
      "/PrintsFile/rpDatHangDaiLyVer2?DatHangID=" +
        orderDatHangID +
        "&tab=orders",
      "_blank",
    );
  };

  const viewDonDatHangGuiNCC = (code) => {
    window.open("/PrintsFile/rpDonGuiDatHang?Code=" + code, "_blank");
  };

  const setFilterCookie = () => {
    const cookie =
      "fromDate::" +
      moment(dataSearch.fromDate).format("YYYY-MM-DD") +
      "&toDate::" +
      moment(dataSearch.toDate).format("YYYY-MM-DD") +
      "&typeDate::" +
      dataSearch.typeDate +
      "&sSearch::" +
      dataSearch.sSearch +
      "&sUserName::" +
      dataSearch.sUserName +
      "&sCustomerName::" +
      dataSearch.sCustomerName +
      "&iTrangThaiTruKho::" +
      dataSearch.iTrangThaiTruKho +
      "&iTrangThaiThanhToan::" +
      dataSearch.iTrangThaiThanhToan +
      "&iBranch::" +
      dataSearch.iBranch +
      "&sBranch::" +
      dataSearch.sBranch +
      "&sNVKDUserName::" +
      dataSearch.sNVKDUserName +
      "&lstNhomKH::" +
      dataSearch.lstNhomKH +
      "&iLoaiDon::" +
      dataSearch.iLoaiDon +
      "&iLoaiDoiTac::" +
      dataSearch.iLoaiDoiTac +
      "&iPageIndex::" +
      dataSearch.iPageIndex;

    const cookies = new Cookies();
    cookies.set("filterDonDatHang", cookie, { path: "/" });
  };

  const handlePageChange = (pageNumber) => {
    if (getBranch() === 0 || getBranch() === "0") {
      const cate = { ...listDonHang };
      let strBranch = "";

      if (cate.List2) {
        cate.List2.map((row) => {
          if (row.IsCheck === 1) {
            strBranch = strBranch + "_" + row.BranchID;
          }
          return row;
        });
      }

      const searchNew = {
        ...dataSearch,
        sBranch: strBranch,
        iPageIndex: pageNumber,
      };

      dispatch(updateDataSearch(searchNew));
      dispatch(getListDanhSachDonDatHang(searchNew));
    } else {
      const searchNew = {
        ...dataSearch,
        iPageIndex: pageNumber,
      };

      dispatch(updateDataSearch(searchNew));
      dispatch(getListDanhSachDonDatHang(searchNew));
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderTableData = () => {
    if (typeof listDonHang?.List !== "undefined" && listDonHang.iTotal !== 0) {
      return listDonHang.List.map((item, index) => (
        <tr key={item.OrderDatHangID || index}>
          <td className="text-center">{item.RowNum}</td>

          <td className="text-left">
            <a
              href={() => false}
              className="iconTable-Main iconW18"
              onClick={(e) => {
                e.preventDefault();
                viewDonDatHang(item.OrderDatHangID);
              }}
            >
              {item.OrderCode}
            </a>
          </td>

          {/* <td className="text-left">
            <a
              href={() => false}
              className="iconTable-Main iconW18"
              onClick={(e) => {
                e.preventDefault();
                viewDonDatHangGuiNCC(item.ImportDatHangCode);
              }}
            >
              {item.ImportDatHangCode}
            </a>
          </td> */}

          <td className="text-right">
            <NumberFormat
              displayType="text"
              value={LamTronNghin(item.TongTien || 0, isLamTronTien)}
              thousandSeparator
            />
          </td>

          <td className="text-center">
            {item.CreatedTime
              ? moment(item.CreatedTime).format("DD/MM/YYYY HH:mm:ss")
              : ""}
          </td>

          <td className="text-center">
            {item.NgayDuKienGiao
              ? moment(item.NgayDuKienGiao).format("DD/MM/YYYY HH:mm:ss")
              : ""}
          </td>

          <td>{item.Note}</td>

          <td className="text-center">
            {item.Approval === 0 && "Chờ chốt"}
            {item.Approval === 1 && "Đã chốt"}
            {item.Approval === 2 && "Không chốt"}
            {item.Approval === 3 && "Lên đơn 1 phần"}
            {item.Approval === 4 && "Hoàn thành"}
          </td>

          <td className="text-right">
            {item.IsSuaDon === 1 &&
              item.Approval === 0 &&
              item.IsMapping === 1 && (
                <>
                  <BtnSua
                    index={index}
                    item={item}
                    setFilterCookie={setFilterCookie}
                  />
                  <BtnXoa index={index} item={item} />
                </>
              )}
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="9" className="giaodich-empty">
          Không có dữ liệu
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="giaodich-summary">
        <div className="giaodich-summary-item">
          <span>Tổng giá trị:</span>
          <b>
            <NumberFormat
              displayType="text"
              value={listDonHang?.TotalValue1 || 0}
              thousandSeparator
            />{" "}
            đ
          </b>
        </div>
      </div>

      <div className="giaodich-table-wrap">
        <table className="giaodich-table">
          <thead>
            <tr>
              <th className="text-center">STT</th>
              <th className="text-left">Mã đơn</th>
              {/* <th className="text-left">Mã đơn đặt</th> */}
              <th className="text-right">Tổng giá trị</th>
              <th className="text-center">Thời gian</th>
              <th className="text-center">Dự kiến giao</th>
              <th className="text-left">Ghi chú</th>
              <th className="text-center">Trạng thái</th>
              <th className="text-right">Thao tác</th>
            </tr>
          </thead>

          <tbody>{renderTableData()}</tbody>
        </table>
      </div>

      {listDonHang?.iTotal > 0 && (
        <div className="paggination-ver2 text-center pagination-Main justify-content-center">
          <div className="total-page">Tổng số {listDonHang.iTotal} bản ghi</div>

          <Pagination
            activePage={dataSearch.iPageIndex || 1}
            itemsCountPerPage={dataSearch.iPageSize || 20}
            totalItemsCount={listDonHang.iTotal}
            pageRangeDisplayed={10}
            onChange={handlePageChange}
            hideNavigation
            itemClass="cssPage-item"
            linkClass="cssPageLink"
            activeClass="cssActiveClass"
          />
        </div>
      )}
    </>
  );
}
